import React, { useContext } from 'react';
import { isMobile } from 'react-device-detect';


import { UmbracoContext, UmbracoStep } from 'components/Umbraco/UmbracoContext';

import utils from 'utils';
import { Between, InnerBig, InnerMedium, LabelSubTitle, Line, LineShrink, LineSmall, Row } from 'meitav-uikit';

const { rest, UmbracoUtills } = utils;

export default function Section3() {
  const resource = UmbracoStep(useContext(UmbracoContext).resource, 'Section3');

  return (
    <Row className="section3 mt-3">
      <InnerBig className="wrapper">
        <Row className={`${isMobile ? 'containerMobile' : ''}`}>
          <Between>
            <div className="borderSection" />
            <div className={`${isMobile ? 'titleMobile col-6' : 'title mx-5'
              }`}>
              <LabelSubTitle className="h1Accibility">
                {UmbracoUtills.getParsedHtmlValueByKey(resource, 'title')}
              </LabelSubTitle>
            </div>
            <div className="borderSection" />
          </Between>
          <Line className="">
            <Row type='small' className="title-and-text-container">
              <div className="title2 ">
                <h3 className="h1Accibility">
                  {UmbracoUtills.getParsedHtmlValueByKey(
                    resource,
                    'notRequiredTitle',
                  )}
                </h3>
              </div>
              <div className=" description mr-3">
                {UmbracoUtills.getParsedHtmlValueByKey(
                  resource,
                  'notRequiredDescription',
                )}
              </div>
            </Row>
            <Row type='small' className={`${isMobile ? 'col-xs-12 mt-3' : 'col-md-5 title-and-text-container'
              }`}>
              <div className="title2">
                <h3 className="h1Accibility">
                  {UmbracoUtills.getParsedHtmlValueByKey(
                    resource,
                    'taxationAdvantageTitle',
                  )}
                </h3>
              </div>
              <div className=" description mr-3">
                {UmbracoUtills.getParsedHtmlValueByKey(
                  resource,
                  'taxationAdvantageDescription',
                )}
              </div>
            </Row>
          </Line>
        </Row>
      </InnerBig>
    </Row>
  );
}
